import $ from 'jquery';

class GoogleTranslator {
    constructor() {
        this.languageSelect = null;
        this.observer = null;
        this.init();
    }

    init() {
        this.waitForDropdown();
    }

    waitForDropdown() {
        const checkExist = setInterval(() => {
            this.languageSelect = $('.goog-te-combo');

            if (this.languageSelect.length) {
                clearInterval(checkExist); // Stop checking
                this.updateDefaultText();  // Modify the first option
                this.observeChanges();      // Watch for changes
            }
        }, 500);
    }

    updateDefaultText() {
        const defaultOption = this.languageSelect.find('option:first-child');

        if (defaultOption.length) {
            defaultOption.text('Language'); // Change this text
        }
    }

    observeChanges() {
        this.observer = new MutationObserver(() => {
            this.updateDefaultText(); // Reapply change if Google modifies it
        });

        this.languageSelect.each((_, select) => {
            this.observer.observe(select, { childList: true, subtree: true });
        });
    }
}

export default GoogleTranslator;